import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  const updated = "2025-11-11"; // 最終更新日を適宜更新

  return (
    <main className="py-20 bg-white text-gray-800">
      <div className="container mx-auto px-4 max-w-5xl">
        {/* 見出し */}
        <div className="mb-8">
          <nav className="text-sm text-gray-500 mb-3">
            <Link to="/" className="hover:underline text-green-800">Home</Link>
            <span className="mx-2">/</span>
            <span>プライバシーポリシー</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-bold text-green-800">
            プライバシーポリシー
          </h1>
          <p className="text-sm text-gray-500 mt-2">最終更新日：{updated}</p>
        </div>

        <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-6 md:p-8 space-y-8 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">1. 事業者情報</h2>
            <p>
              本プライバシーポリシーは、株式会社MELM（以下「当社」）が運営する当サイトにおける
              お客様の個人情報の取り扱い方針を定めるものです。
            </p>
            <ul className="list-disc ml-6 mt-2">
              <li>会社名：株式会社MELM</li>
              <li>代表者：宮下　亜希</li>
              <li>所在地：〒546-0043 大阪府大阪市東住吉区駒川3-27-39 プレジオールKOMAGAWA 204</li>
              <li>電話番号：080-2466-3126 / 050-8894-7919</li>
              <li>連絡先：accounting@melm-inc.com</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">2. 取得する情報</h2>
            <p>当社は、以下の情報を取得することがあります。</p>
            <ul className="list-disc ml-6 mt-2">
              <li>氏名、メールアドレス、電話番号、会社名（店舗名）</li>
              <li>お問い合わせ種別、メッセージ内容</li>
              <li>クッキー等の識別子、IPアドレス、端末情報、アクセスログ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">3. 利用目的</h2>
            <ul className="list-disc ml-6">
              <li>お問い合わせへの回答、見積り・資料送付、各種ご案内のため</li>
              <li>サービスの提供・改善、新機能の開発、品質向上のため</li>
              <li>不正行為の防止・対策、セキュリティ維持のため</li>
              <li>法令・規約に基づく対応のため</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">4. クッキー等の利用</h2>
            <p>
              当サイトでは、利便性向上やアクセス解析のためにクッキー等を使用する場合があります。
              ブラウザの設定によりクッキーを無効にできますが、サイトの一部機能が制限されることがあります。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">5. 第三者提供・委託</h2>
            <p>
              当社は、法令に基づく場合やお客様の同意がある場合を除き、個人情報を第三者へ提供しません。
              なお、業務委託先（サーバー事業者、メール配信事業者等）に取り扱いを委託することがあります。
              この場合、適切な管理・監督を行います。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">6. 安全管理措置</h2>
            <p>
              当社は、個人情報の漏えい・滅失・毀損の防止その他安全管理のため、アクセス制御、
              通信の暗号化、ログ管理等の必要かつ適切な措置を講じます。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">7. 保管期間</h2>
            <p>
              個人情報は、利用目的の達成に必要な範囲で保管し、不要となった場合は
              速やかに消去・匿名化等の措置を講じます。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">8. 開示・訂正・利用停止等の請求</h2>
            <p>
              お客様は、当社が保有するご自身の個人情報について、開示、訂正、追加、削除、利用停止、
              提供停止を求めることができます。下記窓口までご連絡ください。
            </p>
            <p className="mt-2">
              受付窓口：<a href="mailto:accounting@melm-inc.com" className="text-green-800 underline">accounting@melm-inc.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">9. 未成年の個人情報</h2>
            <p>
              未成年者が個人情報を提供する場合は、法定代理人の同意を得たうえでご提供ください。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">10. 法令・規範の遵守と見直し</h2>
            <p>
              当社は、関連法令・ガイドライン等を遵守するとともに、社会情勢やサービス内容の変更に応じ、
              本ポリシーを適宜見直し、改定します。重要な変更がある場合は当サイト上で告知します。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-800 mb-3">11. お問い合わせ窓口</h2>
            <address className="not-italic">
              株式会社MELM<br />
              代表者：宮下　亜希<br />
              〒546-0043 大阪府大阪市東住吉区駒川3-27-39 プレジオールKOMAGAWA 204<br />
              電話番号：080-2466-3126 / 050-8894-7919<br />
              メール：<a href="mailto:accounting@melm-inc.com" className="text-green-800 underline">accounting@melm-inc.com</a>
            </address>
          </section>
        </div>

        {/* 戻るリンク */}
        <div className="mt-10">
          <Link to="/" className="text-green-800 underline font-semibold">トップへ戻る</Link>
        </div>
      </div>
    </main>
  );
}
